import React from 'react';
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
const mainApplicant = '/images/icons/applicant.svg';
const otherAppplicant = '/images/icons/user.svg';
import {
  back_button,
  aplicantList,
  mainApllicant,
  addedDocContaoner,
  scrollbar_none
} from './RequestDocument.module.css';

const ViewRequestedDocs = () => {
  const dummyApplicants = [
    {
      isMainApplicant: true,
      applicant_type: 'Appicant'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    },
    {
      isMainApplicant: false,
      applicant_type: 'Co-Appicant 2'
    }
  ];

  return (
    <div
      className={` text-grey-920 text-base font-roboto font-medium mx-2 my-5`}
    >
      <h3 className="w-full text-black-1010 font-roboto font-medium text-sm mb-4">
        Applicants and Co-Applicants
      </h3>
      <div className="w-ful flex overflow-auto">
        {dummyApplicants.map((each, index) => (
          <ListOfApplicants
            key={index}
            isMainApplicant={each.isMainApplicant}
            applicant_type={each.applicant_type}
          />
        ))}
      </div>
      <div className="w-full px-3 py-3 rounded-md bg-grey-1009 mt-10 mb-6">
        <p className="font-roboto font-normal text-sm text-black ">
          BP/RM Uplopaded Docs <span className="">0/4</span>
        </p>
      </div>

      <div className="w-full">
        <ListOfDocuments />
      </div>
    </div>
  );
};
export default ViewRequestedDocs;

const ListOfApplicants = ({ isMainApplicant, applicant_type }) => {
  return (
    <div
      className={`block ${
        isMainApplicant ? mainApllicant : aplicantList
      } items-center text-center `}
    >
      <img
        src={isMainApplicant ? mainApplicant : otherAppplicant}
        className="w-12 h-10 rounded mx-auto"
      />
      <p className="font-roboto text-center font-normal text-black-500 text-xs my-1">
        {applicant_type}
      </p>
    </div>
  );
};

const ListOfDocuments = () => {
  const docLists = [
    {
      name: 'Loan offer',
      status: 'uploaded'
    },
    {
      name: 'Loan Statement',
      status: 'uploaded'
    },
    {
      name: 'GST Return File',
      status: 'uploaded'
    },
    {
      name: 'Form 26a',
      status: 'uploaded'
    }
  ];
  return (
    <div className="">
      <div className="">
        {docLists.map((each, index) => (
          <div className="w-full flex items-center my-2" key={index}>
            <div className="mr-2">
              <CheckCircleIcon style={{ color: '#1DC321', width: '15px' }} />
            </div>
            <p className="font-roboto font-normal ">{each.name}</p>
          </div>
        ))}
      </div>
    </div>
  );
};
